/**
 * Engineered proof slideshow — fade between car slides with autoplay.
 */
(function () {
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (!root || root.dataset.wpmProofReady === 'true') return;
    root.dataset.wpmProofReady = 'true';

    var slides = root.querySelectorAll('[data-wpm-proof-slide]');
    var dots = root.querySelectorAll('[data-wpm-proof-dot]');
    var prev = root.querySelector('[data-wpm-proof-prev]');
    var next = root.querySelector('[data-wpm-proof-next]');
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;
    var interval = Number(root.getAttribute('data-autoplay') || 0);
    var paused = false;

    function setActive(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, si) {
        var on = si === index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (dot, di) {
        var on = di === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    function go(delta) {
      setActive(index + delta);
      restart();
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (paused || REDUCE.matches || interval < 1) return;
      timer = window.setInterval(function () {
        setActive(index + 1);
      }, interval);
    }

    function restart() {
      stop();
      start();
    }

    prev?.addEventListener('click', function () {
      go(-1);
    });
    next?.addEventListener('click', function () {
      go(1);
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = Number(dot.getAttribute('data-wpm-proof-index') || 0);
        setActive(i);
        restart();
      });
    });

    root.addEventListener('mouseenter', function () {
      paused = true;
      stop();
    });
    root.addEventListener('mouseleave', function () {
      paused = false;
      start();
    });
    root.addEventListener('focusin', function () {
      paused = true;
      stop();
    });
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) {
        paused = false;
        start();
      }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else if (!paused) start();
    });

    REDUCE.addEventListener('change', function () {
      if (REDUCE.matches) stop();
      else if (!paused) start();
    });

    setActive(0);
    start();
  }

  function boot() {
    document.querySelectorAll('[data-wpm-engineered-proof]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-wpm-engineered-proof]');
    if (root) {
      root.dataset.wpmProofReady = 'false';
      init(root);
    }
  });
})();
